import { useQuery } from "@apollo/client";
import { GET_TENANT_FAX_LINES } from "../queries/clients";

/**
 * @typedef {Object} TenantDid
 * @property {string} description
 * @property {string} did
 * @property {string} clientId
 */

/**
 * @typedef {Object} UseTenantFaxLinesResult
 * @property {TenantDid[]} tenantDids
 * @property {boolean} loading
 * @property {Error|null} error
 */

/**
 * Custom hook - fetch tenant dids.
 *
 * @param {number} clientId
 * @param {Object} [options]
 * @returns {UseTenantFaxLinesResult}
 */
export const useTenantFaxLines = (clientId, options = {}) => {
  const skip = !clientId;

  const { data, loading, error } = useQuery(GET_TENANT_FAX_LINES, {
    variables: { clientId },
    skip,
    notifyOnNetworkStatusChange: true,
    ...options,
  });

  const tenantDids = data?.tenantDids ?? [];

  return {
    tenantDids,
    loading,
    error,
  };
};
